module.exports = __webpack_public_path__ + "img/wifi-analysis-sdk.52dc409.png";